import { WAITING } from '../actions/types';

function waitingReducer(state = [], action) {
	switch (action.type) {
		case WAITING:
			return action.payload || false;
		default:
			return state;
	}
}

export default waitingReducer;
